import React, { Fragment, useState } from "react";
import Modal from "react-modal";

export function ErrorModal(props) {
  const { isVisible, setVisible } = props;

  return (
    <Modal
      isOpen={isVisible}
      // onAfterOpen={afterOpenModal}
      onRequestClose={() => setVisible(false)}
      style={customStyles}
      contentLabel="Verification Code"
    >
      <button className="btn modal-close-btn" onClick={() => setVisible(false)}>
        <i className="fas fa-times"></i>
      </button>
      <h2 className="text-danger text-center">
        <i class="fas fa-exclamation-circle"></i> Sorry for the inconvenience
      </h2>
      <h5>
        Something happened on our end. Please refresh, try again later or
        contact us.{" "}
      </h5>
    </Modal>
  );
}

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    maxWidth: "500px",
  },
};
